import styled from 'styled-components';

const Title = styled.h3`
  margin: 0;
  font-size: 2.4rem;
`;

export { Title as TitleStyled };
